var isKind = require('./isKind');
    /**
     */
    function isBoolean(val) {
        return isKind(val, 'Boolean');
    }
    module.exports = isBoolean;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isBoolean.js
// module id = 1605
// module chunks = 0 1 2